import React, { Component } from 'react';
import { DetailsList, DetailsListLayoutMode, SelectionMode } from '@fluentui/react/lib/DetailsList'
import { IconButton } from '@fluentui/react';
import { Collapsible } from '../Controls/Collapsible';


export class QuoteHistoryList extends Component {
    static displayName = QuoteHistoryList.name;

    constructor(props) {
        super(props)

        this.onItemClick = this.onItemClick.bind(this);
    }
    componentDidMount() {

    }
    onItemClick(item) {
        if (this.props.onOpen) {
            this.props.onOpen(item);
        }
    }

    render() {
        var columns = [{
            key: "dateKey",
            fieldName: "lastSavedOn",
            name: "Date",
            minWidth: 200,
            maxWidth: 200
        },
        {
            key: "calcVersionKey",
            fieldName: "formulaVersion",
            name: "Calc Ver.",
            minWidth: 200,
            maxWidth: 200
        },
        {
            key: "productKey",
            fieldName: "smsTypeText",
            name: "Product",
            minWidth: 200,
            maxWidth: 200
        },
        {
            key: "nonRecurringKey",
            fieldName: "totalInitialFees",
            name: "NRC",
            minWidth: 200,
            maxWidth: 200
        }, {
            key: "insuranceKey",
            fieldName: "cyberInsuranceFee",
            name: "Insurance",
            minWidth: 200,
            maxWidth: 200
        }, {
            key: "monthlyKey",
            fieldName: "totalSmsMonthlyFees",
            name: "Monthly",
            minWidth: 200,
            maxWidth: 200
        }, {
            key: "blockTimeKey",
            fieldName: "blockTimeExtPrice",
            name: "BlockTime",
            minWidth: 200,
            maxWidth: 200
        },
        {
            key: "actionsKey",
            name: "Actions",
            onRender: (item) => {
                return (<IconButton iconProps={{ iconName: "OpenFile" }} onClick={() => { this.onItemClick(item) }} />)
            }
        }
        ];
        var items = [];
        if (this.props.items) {
            items = this.props.items;
        }
            return (
            <div>
                <Collapsible header={"Estimate History"}>
                    <DetailsList
                        items={items}
                        columns={columns}
                        selectionMode={SelectionMode.none}
                        layoutMode={DetailsListLayoutMode.justified}
                        isCompactMode={true}

                    />
                </Collapsible>
            </div>)
    }
}